import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"d-flex align-center",staticStyle:{"height":"100vh"},attrs:{"fluid":""}},[_c(VRow,[_c('h1',[_vm._v("Authenticating Telegram")]),_c('p',[_vm._v("Associating Telegram to your Swiset user...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }